function trimLeftSlash (str: string) {
  return str.replace(/^\//, '');
}

export default function useApiUrl (relativeUri: string) {
  const config = useRuntimeConfig();
  return [config.public.proxyPrefix, 'public/learning-app', trimLeftSlash(relativeUri)].join('/');
}
